export default "__VITE_ASSET__DlKAFwco__"